import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  0% {\n    opacity: 1;\n    transform: translate(0, -100%) rotateZ(0deg);\n  }\n\n  75% {\n    opacity: 1;\n    transform: translate(100px, 75vh) rotateZ(270deg);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translate(150px, 100vh) rotateZ(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  position: fixed;\n  top: 0;\n  left: ",
        ";\n  transform: translate3d(0, -100%, 0);\n  user-select: none;\n  pointer-events: none;\n  z-index: 99999;\n\n  animation-name: ",
        ";\n  animation-duration: ",
        ";\n  animation-timing-function: linear;\n  animation-iteration-count: ",
        ";\n  animation-play-state: running;\n\n  &:nth-child(5n + 5) {\n    animation-delay: ",
        ";\n  }\n\n  &:nth-child(3n + 2) {\n    animation-delay: ",
        ";\n  }\n\n  &:nth-child(2n + 5) {\n    animation-delay: ",
        ";\n  }\n\n  &:nth-child(3n + 10) {\n    animation-delay: ",
        ";\n  }\n\n  &:nth-child(7n + 2) {\n    animation-delay: ",
        ";\n  }\n\n  &:nth-child(4n + 5) {\n    animation-delay: ",
        ";\n  }\n\n  &:nth-child(3n + 7) {\n    animation-delay: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled, { keyframes } from "styled-components";
import BunnyIcon from "../Svg/Icons/Logo";
var bunnyFall = keyframes(_templateObject());
var Bunny = styled.div.withConfig({
    componentId: "sc-5643275b-0"
})(_templateObject1(), function(param) {
    var position = param.position;
    return "".concat(position, "vw");
}, bunnyFall, function(param) {
    var duration = param.duration;
    return "".concat(duration, "s");
}, function(param) {
    var iterations = param.iterations;
    return Number.isFinite(iterations) ? String(iterations) : "infinite";
}, function(param) {
    var duration = param.duration;
    return "".concat(duration / 10 * 1.3, "s");
}, function(param) {
    var duration = param.duration;
    return "".concat(duration / 10 * 1.5, "s");
}, function(param) {
    var duration = param.duration;
    return "".concat(duration / 10 * 1.7, "s");
}, function(param) {
    var duration = param.duration;
    return "".concat(duration / 10 * 2.7, "s");
}, function(param) {
    var duration = param.duration;
    return "".concat(duration / 10 * 3.5, "s");
}, function(param) {
    var duration = param.duration;
    return "".concat(duration / 10 * 5.5, "s");
}, function(param) {
    var duration = param.duration;
    return "".concat(duration / 10 * 8, "s");
});
var FallingBunnies = function(param) {
    var _count = param.count, count = _count === void 0 ? 30 : _count, _size = param.size, size = _size === void 0 ? 32 : _size, _iterations = param.iterations, iterations = _iterations === void 0 ? Infinity : _iterations, _duration = param.duration, duration = _duration === void 0 ? 10 : _duration;
    var bunnies = _to_consumable_array(Array(count)).map(function(_, index) {
        return(// eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ _jsx(Bunny, {
            position: Math.random() * 100,
            iterations: iterations,
            duration: duration,
            children: /*#__PURE__*/ _jsx(BunnyIcon, {
                width: size,
                height: size
            })
        }, String(index)));
    });
    return /*#__PURE__*/ _jsx("div", {
        children: bunnies
    });
};
export default FallingBunnies;
